import { render, staticRenderFns } from "./banner_list.vue?vue&type=template&id=2b7fab48&scoped=true"
import script from "./banner_list.vue?vue&type=script&lang=js"
export * from "./banner_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7fab48",
  null
  
)

export default component.exports